import { render, staticRenderFns } from "./orderPayment.vue?vue&type=template&id=06d2a80b&scoped=true&"
import script from "./orderPayment.vue?vue&type=script&lang=js&"
export * from "./orderPayment.vue?vue&type=script&lang=js&"
import style0 from "./orderPayment.vue?vue&type=style&index=0&id=06d2a80b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d2a80b",
  null
  
)

export default component.exports